import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=1a95ba0b&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a95ba0b')) {
      api.createRecord('1a95ba0b', component.options)
    } else {
      api.reload('1a95ba0b', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=1a95ba0b&", function () {
      api.rerender('1a95ba0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YTllu34z80my/JS/imageCarousel.vue"
export default component.exports